import {faQuestionCircle} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {OverlayTrigger} from '@freckle/educator-materials/ts/components/overlay-trigger'
import {Popover} from '@freckle/educator-materials/ts/components/popover'
import {Text} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {icon} from './index.module.scss'

type Props = {
  id: string
}

export function IDPSyncPopover(props: Props) {
  const {t} = useSafeTranslation()

  const popover = (
    <Popover id={props.id}>
      <Text style="subtitle-2">{t('MANAGE_DASHBOARD_IDP_SYNC_POPOVER_SUBTITLE')}</Text>
      <p>{t('MANAGE_DASHBOARD_IDP_SYNC_POPOVER_BODY')}</p>
    </Popover>
  )

  return (
    <OverlayTrigger trigger={['click']} placement="top" overlay={popover}>
      <FontAwesomeIcon icon={faQuestionCircle} className={`hidden-print ${icon}`} />
    </OverlayTrigger>
  )
}
